(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('EnviarSolicitudController', EnviarSolicitudController);

    EnviarSolicitudController.$inject = ['$uibModalInstance', '$rootScope', '$state', 'entity', 'SSProyecto', 'SSPeriodo'];

    function EnviarSolicitudController($uibModalInstance, $rootScope, $state, entity, SSProyecto, SSPeriodo) {
        var vm = this;

        vm.sSProyecto = entity;
        vm.clear = clear;
        vm.confirmSend = confirmSend;        

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
		function confirmSend() {
			SSProyecto.register(vm.sSProyecto, onSaveSuccess, onSaveError);			
		}
		
		function onSaveSuccess(result) {
        	$uibModalInstance.close(true);
			$state.go('ss-proyectos');
			$rootScope.$broadcast('sendSolicitudSuccess');
		}

		function onSaveError() {
		}
		
    }
})();
